import { h } from 'vue';
import { Modal } from 'ant-design-vue';

const ModalClass = {
  install(app) {
    const App = app.config.globalProperties;

    App.$showConfirm = (contents = [], title = '') => new Promise((resolve, reject) => {
      let elm = '';
      if (contents.length === 0) {
        elm = [
          h('div', 'ページの再読み込みを行うと'),
          h('div', '入力内容が全てクリアされます。')
        ];
      } else {
        elm = contents.map(content => h('div', content));
      }
      Modal.confirm({
        title: title || 'ページの再読み込みを行いますか？',
        content: h('div', {}, elm),
        okText: 'OK',
        cancelText: 'キャンセル',
        onOk: () => Promise.resolve(resolve(true)),
        onCancel: () => Promise.resolve(resolve(false))
      });
    });
  }
};

export default ModalClass;
